export default __webpack_public_path__ + "static/media/photo--lg--misc-10.29a6d94a.jpg";